import DirectionsCarOutlined from '@mui/icons-material/DirectionsCarOutlined';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import { Link as RouterLink } from 'react-router';

import { useCarOrderStore } from '@/stores/carOrderStore';

/** Header link to the car cart. Hidden until the visitor has added a car. */
export function CarOrderButton({ color = 'inherit' }: { color?: string }) {
  const count = useCarOrderStore((s) => s.items.length);
  if (count === 0) return null;
  const label = `Your car cart, ${count} ${count === 1 ? 'car' : 'cars'}`;
  return (
    <IconButton component={RouterLink} to="/cars/cart" aria-label={label} title={label} sx={{ color }}>
      <Badge badgeContent={count} color="primary">
        <DirectionsCarOutlined />
      </Badge>
    </IconButton>
  );
}
